import React, { useState, createContext, useEffect, useCallback } from "react";

// Decide between `localStorage` or `sessionStorage`
const STORAGE_KEY = "cart";
const getStoredCart = () =>
  JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];

export const CartContext = createContext();

export const CartContextProvider = ({ children }) => {
  const [cart, setCart] = useState(getStoredCart);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
  }, [cart]);

  /** ✅ Add to Cart: If product exists, increase quantity; otherwise, add */
  const addToCart = useCallback((product, addQuantity) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item._id === product._id);
      console.log("addToCart", existingProduct);

      if (existingProduct) {
        return prevCart.map((item) =>
          item._id === product._id
            ? {
                ...item,
                cartQuantity: item.cartQuantity + parseInt(addQuantity),
                error:
                  item.cartQuantity + parseInt(addQuantity) >
                  item.sellable_stock,
              }
            : item
        );
      } else {
        return [
          ...prevCart,
          {
            ...product,
            cartQuantity: parseInt(addQuantity),
            error: parseInt(addQuantity) > product.sellable_stock,
          },
        ];
      }
    });
  }, []);

  /** ✅ Function to set product quantity */
  const changeProductQuantity = useCallback((productId, newQuantity) => {
    setCart((prevCart) => {
      const quantity = parseInt(newQuantity, 10);

      // ✅ Check if the product exists in the cart
      return prevCart.map((item) =>
        item._id === productId
          ? {
              ...item,
              cartQuantity: quantity,
              error: quantity > item.sellable_stock,
            }
          : item
      );
    });
  }, []);

  /** ✅ Remove one item from the cart */
  const removeFromCart = useCallback((productId) => {
    setCart((prevCart) => {
      return prevCart
        .map((item) =>
          item._id === productId
            ? {
                ...item,
                cartQuantity: item.cartQuantity - 1,
                error: item.cartQuantity - 1 > item.sellable_stock,
              }
            : item
        )
        .filter((item) => item.cartQuantity > 0);
    });
  }, []);

  /** ✅ Remove an entire product from the cart */
  const removeProduct = useCallback((productId) => {
    setCart((prevCart) => prevCart.filter((item) => item._id !== productId));
  }, []);

  /** ✅ Clear entire cart */
  const clearCart = useCallback(() => {
    setCart([]);
  }, []);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        removeProduct,
        clearCart,
        changeProductQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
